// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from "vue";
import App from "./App";
import store from "./vuex";
import router from "./router";
import ECharts from "vue-echarts";
import filters from "./gadgets/filters";
import * as timeGadgets from "./gadgets/timeGadgets";

import "echarts/lib/chart/pie"; // 圆饼图
import "echarts/lib/component/title"; // 图表标题
import "echarts/lib/component/legend"; // 图例
import "echarts/lib/component/tooltip"; // 提示

import element from "element-ui";
import containerMain from "./components/container-main";
import containerMainMobile from "./components/container-main-mobile";
import cHeader from "./components/contentHeader";
import cHeaderSmall from "./components/contentHeader-small";
import cBox from "./components/contentBox";
import dataRow from "./components/dataRow";
import verifier from "./components/verifier";
import regex from "./gadgets/regex";
import { library } from "@fortawesome/fontawesome-svg-core";
import { fas } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import Clipboard from "v-clipboard";
import VueQriously from "vue-qriously";
import mathjs from "mathjs";
import zoom from "vue-image-zoom";
import "vue-image-zoom/dist/vue-image-zoom.css";
import { IEVersion } from "./gadgets/tools"
Vue.use(Clipboard);
Vue.use(VueQriously);
Vue.prototype.$math = mathjs;
Vue.use(zoom);

library.add(fas);
Vue.component("fa-icon", FontAwesomeIcon);

Vue.component("v-chart", ECharts);

Vue.component("containerMain", containerMain);
Vue.component("containerMainMobile", containerMainMobile);
Vue.component("cHeader", cHeader);
Vue.component("cHeaderSmall", cHeaderSmall);
Vue.component("cBox", cBox);
Vue.component("dataRow", dataRow);
Vue.component("verifier", verifier);

Vue.use(element);

// 初始化上报
try {
  window.rfReport = new RfReport({
    domain: process.env.VUE_APP_PROXY_ENV === 'product' ? 'https://act.thinkinpower.com/analytics' : 'https://act.test.thinkinpower.net/analytics',
    isAutoReport: false,
    autoTime: 10 * 1000,
    debugger: process.env.VUE_APP_PROXY_ENV === 'product' ? false : true,
    isUse: true,
    // ajax请求时需要过滤的url信息
    filterUrl: ['list_user_download'],
    // 是否上报页面性能数据
    isPage: true,
    // 是否上报ajax性能数据
    isAjax: false,
    // 是否上报页面资源数据
    isResource: false,
    // 是否上报错误信息
    isError: true,
    isDebugger: false,
    // 是否延迟上报
    isDelayReport: true,
    config: {
      app_id: '74e168ad5cc790520dad812e3e595b04',
      module: 'PLATFORM_PC_MCH',
    }
  })
} catch (error) {
  console.log('实例化上报', error)
}

router.beforeEach((to, from, next) => {
  try {
    window.rfReport.reportData()
  } catch (error) {
    console.log('rfReport路由守卫报错====>', error);
  }

  const isLogin = store.getters.isLogin;
  const ignore = store.getters.browser.ignore;
  const name = to.name + "";
  const fname = from.name + "";
  const ieVer = IEVersion()
  // 判断浏览器，如果浏览器是IE做兼容处理
  if (ieVer === 11 ||ieVer === 10 || ieVer === 9 || ieVer === 8 || ieVer === 7 || ieVer === 6) {
    // 是否略过浏览器判断强行浏览
    if (!ignore) {
      if (name !== 'browser') {
        // IE浏览器，且低于IE11
        next({ path: "/browser", query: { ...to.query, path: to.path } })
      } else {
        next()
      }
      return
    }
  }

  if (
    name !== "login" &&
    name !== "withdraw" &&
    name !== "forgetPassword" &&
    name !== 'browser' &&
    !name.match(/reg-1/) &&
    !isLogin
  ) {
    store
      .dispatch("CHECK_LOGIN")
      .then(() => {
        next();
      })
      .catch(({ status, message }) => {
        console.error({ status, message });
        next({ path: "/login", query: { status, message } });
      });
  } else {
    next();
  }
});



Vue.prototype.$datetimeFormatter = timeGadgets.datetimeFormatter;
Vue.prototype.$dateFormatter = timeGadgets.dateFormatter;
Vue.prototype.$monthFormatter = timeGadgets.monthFormatter;
Vue.prototype.$today = timeGadgets.getToday;

Vue.prototype.$timeGadgets = timeGadgets;

Vue.prototype.$regex = regex;

Object.keys(filters).forEach((key) => {
  Vue.filter(key, filters[key]);
});

Vue.config.productionTip = false;

/* eslint-disable no-new */
new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
